export default __webpack_public_path__ + "static/media/demoImg.963891d9.jpg";